export const SearchIcon = ({ color = "#7C7B7B", size = 12, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.41706 7.49888H7.93349L7.76209 7.33361C8.36197 6.6358 8.72311 5.72987 8.72311 4.74437C8.72311 2.54688 6.94186 0.765625 4.74437 0.765625C2.54688 0.765625 0.765625 2.54688 0.765625 4.74437C0.765625 6.94186 2.54688 8.72311 4.74437 8.72311C5.72987 8.72311 6.6358 8.36197 7.33361 7.76209L7.49888 7.93349V8.41706L10.5595 11.4715L11.4715 10.5595L8.41706 7.49888ZM4.74437 7.49888C3.2202 7.49888 1.98985 6.26853 1.98985 4.74437C1.98985 3.2202 3.2202 1.98985 4.74437 1.98985C6.26853 1.98985 7.49888 3.2202 7.49888 4.74437C7.49888 6.26853 6.26853 7.49888 4.74437 7.49888Z"
            fill={color}
        />
    </svg>
);
